import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
//import "rxjs/Rx";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private http: HttpClient
  ) { }

  private currentUserSource = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser') || '{}'));
  public currentUser = this.currentUserSource.asObservable();
  private authUrl = environment.apiUrl+'api/';
  private batchUrl = environment.apiUrl + 'api/batches/';

  public changeUser(obj: any)
  {
    localStorage.setItem('currentUser', JSON.stringify(obj));
    //this.currentUserSource.next(obj);
  }

  //Author Arnab
  public login(data:any){
    return this.http.post(this.authUrl+'fs-login', data);
  }

  //Author Arnab
  public forgotPassword(data:any){
    return this.http.post(this.authUrl+'forgot-password', data);
  }

  //Author Arnab
  public resetPassword(data:any) {
    return this.http.post(this.authUrl+'reset-password', data);
  }

  public changePassword(data:any){
    return this.http.post(this.authUrl+'change-password', data);
  }

  //Author Arnab
  public checkToken(data:any) {
    return this.http.post(this.authUrl+'check-token', data);
  }

  //Author Arka
  logout() {
    //getting the localstorage value
    let currentUser: any = JSON.parse(localStorage.getItem('currentUser') || '{}');
    return this.http.get(this.authUrl+'logout?token='+currentUser.token);
  }

  // public screenCheck(url,role_id) {
  //   let data = {
  //     url: url,
  //     role_id: role_id
  //   };
  //   return this.http.post(this.authUrl+'check-screen',data);
  // }

  public getDeepTechBatches() {
    return this.http.get(this.batchUrl+'get-deep-tech-calender-batches');
  }

}
